import { Injectable } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';

@Injectable({
  providedIn: 'root'
})
export class TutorialsService {

  constructor(
    private readonly _shepherdService: ShepherdService
  ) { }

  startTour() {
    this._shepherdService.start();
  }

  addSteps(steps: any) {
    this._shepherdService.addSteps(steps);
  }

  isModal(modal: boolean) {
    this._shepherdService.modal = modal;
  }

  optionsTour(options: any) {
    this._shepherdService.defaultStepOptions = options;
  }

  completeTour(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this._shepherdService.tourObject.on('complete', () => {
        resolve(true);
      });
    });
  }

  skippedTour(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this._shepherdService.tourObject.on('cancel', () => {
        resolve(true);
      });
    });
  }

}
